import React from 'react'
import { NavLink } from 'react-router-dom'

import buttonStyles from '../../../components/Button/Button.module.scss'

export const NoEmailIntegration: React.FC = () => {
  return (
    <p>
      You don't have any email integrations configured. Please connect your email account on the{' '}
      <NavLink className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium d-inline-block`} to={`/account/profile-settings/integrations`}>
        Integrations page
      </NavLink>
      .
    </p>
  )
}
